import { Component, Input } from '@angular/core';

import { User } from '../user';

@Component({
  selector: 't-user-extras',
  templateUrl: './extras.component.html',
})
export class UserExtrasComponent {

  @Input()
  user: User
}
